import img1 from "../Assets/imgIntegrantes/CRISTIAN DURBAN ACTOR PRINCIPAL.png"
import img2 from "../Assets/imgIntegrantes/DANIEL VILLEGAS DIRECCION DE MUSICA.png"
import img3 from "../Assets/imgIntegrantes/FACU DIRECTOR.jpg"
import img4 from "../Assets/imgIntegrantes/JOAQUIN DEMA ASISTENTE DE DIRECCION.jpg"
import img5 from "../Assets/imgIntegrantes/NOE CARRIZO ESCENOGRAFA.png"
import img6 from "../Assets/imgIntegrantes/SARA GUILLEN Asistente de produccion sustentable.png"

export const cardIntegrantes = [
{
    id: 1,
    nombre: "Cristian Durban",
    rol: "Actor Principal",
    ig: "cristian_durban",
    img : img1
},
{
    id: 2,
    nombre: "Daniel Villegas",
    rol: "Director de Musica",
    ig: "Daniel Villegas",
    img : img2,
},
{
    id: 3,
    nombre: "Facundo Graziano",
    rol: "Director",
    ig: "Facugraziano36",
    img : img3,
},
{
    id: 4,
    nombre: "Joaquin Dema",
    rol: "Asistente de Director",
    ig: "joakkilo",
    img : img4,
},
{
    id: 5,
    nombre: "Noe Carrizo",
    rol: "Productora y Diseñadora de Arte",
    ig: "noecarrizoasesora",
    img : img5,
},
{
    id: 6,
    nombre: "Sara Guillen",
    rol: "Asistente de Produccion Sustentable",
    ig: "sarasalada",
    img : img6,
}
]